import { DrawerState } from "./contact.types";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export type ContactErrors = {
  name?: string;
  salutation?: string;
  organization?: string;
  email?: string;
  whatappNumber?: string;
  countryCode?: string;
  channels?: string; // "either email or whatsapp"
};

export const validateContact = (s: DrawerState): ContactErrors => {
  const e: ContactErrors = {};

  if (!s.salutation) e.salutation = "Salutation is required";
  if (!s.name.trim()) e.name = "Name is required";
  if (!s.organization) e.organization = "Organization is required";

  if (!s.email && !s.whatappNumber) {
    e.channels = "Either Email or WhatsApp number is required";
  }
  if (s.email && !emailRegex.test(s.email)) {
    e.email = "Invalid email address";
  }
  if (s.whatappNumber) {
    if (s.whatappNumber.length !== 10) e.whatappNumber = "WhatsApp number must be 10 digits";
    if (!s.countryCode) e.countryCode = "Country code is required with WhatsApp number";
  }
  if (s.countryCode && !s.whatappNumber) {
    e.countryCode = "Country code needs a WhatsApp number";
  }

  return e;
};

// Derive allowed channels from what the contact has
export const deriveAllowedChannels = (s: DrawerState): string[] => {
  const ch: string[] = [];
  if (s.email) ch.push("email");
  if (s.whatappNumber) ch.push("whatsapp");
  return ch;
};